import React from 'react'
import styled from 'react-emotion'
import { color } from 'stylist'

const Container = styled.div`
  color: ${color('white')};
`

const RouteVersion = () => (
  <Container>{process.env.REACT_APP_GIT_REVISION || 'development'}</Container>
)

export default RouteVersion



// WEBPACK FOOTER //
// ./src/routes/version.js